import { render } from "./BatchShow.vue?vue&type=template&id=1e8f34ce&scoped=true"
import script from "./BatchShow.vue?vue&type=script&lang=js"
export * from "./BatchShow.vue?vue&type=script&lang=js"

import "./BatchShow.vue?vue&type=style&index=0&id=1e8f34ce&scoped=true&lang=css"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8f34ce"]])

export default __exports__